<!-- eslint-disable -->
<template lang="pug">
    svg(:width="elemWidth" height="41" xmlns="http://www.w3.org/2000/svg" :viewBox="`0 0 ${elemWidth} 41`")
        path(:d="generatePath(elemWidth)" fill="none" stroke="black")
</template>

<script>
/*eslint-disable*/

export default {
    props: {
        elemWidth: {
            type: Number,
            default: 120,
        },
    },
    methods: {
        generatePath(elemWidth) {
            return `M1 41C1 -8.95131 ${elemWidth - 1} -15.6115 ${elemWidth - 1} 41`;
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
